import { useState } from "react";
import { AgGridReact, DropdownButton, Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { RemoveWorkspaceAccessModal } from "../RemoveWorkspaceAccessModal";
import { buttonContainer, dropdownButtonContainer } from "./style_vanilla.css";
import type { ArenaAccessRow } from "~/pages/Dashboard/components/WorkspaceTable";

type EllipsisButtonUserInfo = {
  userName?: string;
  userId?: string;
};

type EllipsisButtonProps = AgGridReact.CustomCellRendererProps<ArenaAccessRow> & {
  userInfo?: EllipsisButtonUserInfo;
};

export const EllipsisButton = (params: EllipsisButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const rowData = params.data;

  if (!rowData) {
    return <Flex className={buttonContainer} />;
  }

  const handleRemoveFromWorkspace = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const userName = params.userInfo?.userName || "";
  const userId = params.userInfo?.userId || "";

  return (
    <>
      <RemoveWorkspaceAccessModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        workspaceName={rowData.arenaName}
        userName={userName}
        arenaId={rowData.arenaId}
        userId={userId}
      />
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end"
        className={buttonContainer}
      >
        <DropdownButton
          variant="muted"
          icon="ellipsis-h"
          direction="down"
          align="right"
          usePortal
          dropdownActionClassName={dropdownButtonContainer}
        >
          <DropdownButton.Action onSelect={handleRemoveFromWorkspace}>
            <Flex alignItems="center" gap={8} className={dropdownButtonContainer}>
              <Icon type="minus-circle" />
              <Text>Remove workspace access</Text>
            </Flex>
          </DropdownButton.Action>
        </DropdownButton>
      </Flex>
    </>
  );
};
